/**
 * Dashboard > Dashboard - 월별 Fab 이상 검출 건수 조회 component
 */
import API from '@/views/Fdc/Apis/'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

export default {
  name: 'MonthlyFaultStatsByFab',
  mounted () {
    this.search()
  },
  methods: {
    /**
     * Chart Data 조회 (월별 Fab 이상 검출 건수)
     */
    async search () {
      const payload = {
        // fab: 'BRIQUE' // TODO :: 처리 필요
      }

      await API.Monitor.getMonthlyFaultStatsByFab(payload, this.callbackMonthlyFaultStatsByFab, [this.$refs.monthlyFaultStatsByFabChart])
    },
    /**
     * Chart Data 조회 callback
     * @param {*} response Chart Data 조회 결과
     */
    callbackMonthlyFaultStatsByFab (response) {
      if (response && response.status === 200) {
        this.drawChart(response.data)
      }
    },
    /**
     * setInterval 설정
     * @param {*} nSelIndex chart data index
     * 주기적으로 실행하면서 선택된 chart의 data를 조회하여 data가 있을경우 cleareInterval을 실행합니다.
     */
    resetInterval (nSelIndex) {
      let self = this
      var flex = this.$refs.monthlyFaultStatsByFabChart.chart
      this.interval = setInterval(function () {
        flex.selection = flex.series[0]
        var ele = flex.selection.getPlotElement(nSelIndex)
        if (ele) {
          clearInterval(self.interval)
          flex.selection.collectionView.currentItem = flex.selection.collectionView.items[nSelIndex]
          flex.selection.collectionView.currentPosition = nSelIndex
        }
      }, this.updateInterval)
    },
    /**
     * Draw Chart
     * @param {*} traces plotly chart data
     */
    drawChart (traces) {
      traces.forEach(trace => {
        trace.type = 'bar'
        trace.hovertemplate = '%{y:,}'
      })
      const layout = {
        // barmode: 'stack',
        legend: {
          orientation: 'h',
          y: 1.2
        },
        hovermode: 'x unified'
      }
      const config = {
        responsive: true,
        displayModeBar: false,
        displaylogo: false
      }
      BriqueChart.newPlot('monthlyFaultStatsByFabChart', traces, layout, config).then(() => {
        let chart = document.querySelector('#monthlyFaultStatsByFabChart')
        chart.on('plotly_click', event => this.plotlyClick(event.points[0].label))
        if (traces.length > 0) {
          if (traces[0].x.length > 0) {
            var nMonth = traces[0].x[traces[0].x.length - 1]
            this.plotlyClick(nMonth)
          } else {
            this.plotlyClick(new Date().getUTCMonth() + 1)
          }
        }
      })
    },
    /**
     * Chart Click Method
     * @param {*} date 클릭된 point의 월 data
     */
    plotlyClick (date) {
      this.$emit('data-selected', {
        fab: 'BRIQUE',
        date: date
      })
    }
  },
  data () {
    return {
      rowData: [], // chart data
      interval: null, // interval 객체
      updateInterval: 1000 // interval
    }
  }
}
